
// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { Nav, Navbar, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './style.css';

export default function BottomMenu() {
  const { t } = useTranslation('translation', { keyPrefix: 'menu' });

  let entityKey = 0;

  return (
    <Navbar className="bottom-menu" fixed="bottom" bg="dark" variant="dark">
      <Container>
        <Nav>
          <Nav.Link className="nav-link-bottom" eventKey={entityKey++} as={Link} to="/privacypolicy" style={{ whiteSpace: 'nowrap' }}>{t('privacy')}</Nav.Link>
          <Nav.Link className="nav-link-bottom" eventKey={entityKey++} as={Link} to="/termsandconditions" style={{ whiteSpace: 'nowrap' }}>{t('terms')}</Nav.Link>
          <Nav.Link className="nav-link-bottom" eventKey={entityKey++} as={Link} to="/disclaimer" style={{ whiteSpace: 'nowrap' }}>{t('disclaimer')}</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}
